export function deToNumberString(value) {
    value = value.replace(/\./g, '')
    value = value.replace(/,/, '.')
    value = value.replace(/,/g, '')
    return value
}

const toDeLocale = (num) => num.toLocaleString('de-DE')
const toCurrency = (num) => num.toLocaleString(
    'de-DE',
    {maximumFractionDigits: 2, minimumFractionDigits: 2}
)

export function numStringToCurrency(numString) {
    return numString === ""
        ? ""
        : toCurrency(Number(numString))
}

const withinRange = (
    value,
    min = Number.NEGATIVE_INFINITY,
    max = Number.POSITIVE_INFINITY
) => Math.min(max, Math.max(value, min))

const transformWithBounds = (numberFormatter) => (props) => (deString) => {
    const numString = deToNumberString(deString)
    return validateNumString(numString, numberFormatter, props.min, props.max)
}

const transformWithBoundsInteger = (numberFormatter) => (props) => (numString) => validateNumString(numString, numberFormatter, props.min, props.max)

const validateNumString = (numString, numberFormatter, min, max) => {
    const num = Number(numString)
    return numString === "" || Number.isNaN(num)
        ? num
        : numberFormatter(withinRange(num, min, max))
}

export const curreyedTransformationWithRequiredLength = (requiredLength) => (props) => (value) => value.slice(0, requiredLength)

export const transformNumber = transformWithBounds(toDeLocale)
export const transformCurrency = transformWithBounds(toCurrency)
export const transformInteger = transformWithBoundsInteger(String)
export const transformYear = transformWithBoundsInteger(String)